
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 72 72"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#231f20"}},[_c('path',{attrs:{"d":"M51 61.7c0 1.1-.9 1.9-1.9 1.9H23c-1.1 0-1.9-.9-1.9-1.9V9c0-1.1.9-1.9 1.9-1.9h26c1.1 0 2 .8 2 1.9v52.7zM21.1 15.4H51M21.1 55.9H51M32.8 11.3h6.3M34.8 59.7h2"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0bdbf6","d":"M40 28h23v15.5H49.8L46.2 47v-3.5H40z"}}),_c('path',{attrs:{"fill":"none","stroke":"#13120d","d":"M38 26h23v15.5H47.8L44.2 45v-3.5H38z"}})])
          )
        }
      }
    